<i18n>
{
  "en": {
    "KPILoadingError": "Error loading one or more KPIs",
    "loading": "Loading..."
  },
  "es": {
    "KPILoadingError": "Error cargando uno o más indicadores",
    "loading": "Cargando..."
  }
}
</i18n>
<template>
  <fragment>
    <v-tooltip top v-if="loading">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-skeleton-loader class="my-2" type="list-item, date-picker-options" style="max-width:350px;" elevation="2"/>
        </div>
      </template>
      <span>{{$t('loading')}}</span>
    </v-tooltip>
    <kpi-card v-else :title="title" :icon-size="iconSize" :value="value" :increment="increment" :icon="icon"
            :class="classes" :unit="unit" :unitPosition="unitPosition" :isCurrencyUnit="isCurrencyUnit"/>
  </fragment>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import { sentryLogException } from '@core/helpers/sentryLogger';
import KpiCard from './KpiCard.vue';

@Component
@Components({ KpiCard })
@MapGetters(['uncubesServerReady', 'kpiStorage', 'predictionPeriodList', 'pointOfSaleList', 'currency'])
@MapActions(['addNotification', 'setLoading'])
export default class KpiComponent extends Vue {
  @Prop({ type: Boolean, default: false }) isManaged;

  unit = ''

  unitPosition = ''

  isCurrencyUnit = ''

  icon = 'mdi-currency-eur';

  classes = 'my-3 mr-md-3 mr-lg-3 mr-xl-3';

  iconSize = 22;

  value = 0.0;

  increment = 0.0;

  kpiType = null;

  loading = false;

  get title() {
    throw new Error('not implemented');
  }

  get readyToCalc() {
    return this.uncubesServerReady && this.predictionPeriodList.length !== 0 && this.pointOfSaleList.length !== 0;
  }

  created() {
    this.loadKPIModel();
    this.unit = this.isCurrencyUnit ? this.currency.symbol : this.unit;
    this.unitPosition = this.isCurrencyUnit ? this.currency.symbolPosition : '';
    if (this.readyToCalc) this.runCalculate();
  }

  loadKPIModel() {
    const model = this.kpiStorage(this.kpiType)(`${this.$route.params.pointOfSaleGuid}-${this.isManaged}`);
    this.value = model?.kpi;
    this.increment = model?.increment;
  }

  async runCalculate() {
    try {
      this.loading = true;
      await this.calculate();
    } catch (err) {
      this.addNotification(createErrorNotification(this.$t('KPILoadingError'), { id: 'KPIError' }));
      sentryLogException(err, 'Error loading one or more KPIs');
    } finally {
      this.loading = false;
    }
  }

  async calculate() {
    // throw new Error('not implemented');
    console.log('Not implemented');
  }

  @Watch('readyToCalc')
  async onReadyToCalc(val) {
    if (val) {
      await this.runCalculate();
    }
  }

  @Watch('isManaged')
  async onIsManaged() {
    await this.runCalculate();
  }
}
</script>
